import AddPetModal from './AddPetModal';
import axios from 'axios';
import React, { useState, useEffect, useRef } from 'react';
import { apiClient, showToast } from '../../utils/apiClient';
import { API } from '../../config';
import { formatDate, formatDateTime, formatNotesWithBullets, getDayOfWeek, formatDateWithDay, getLocationDisplay, getLocationChipColor, getRowAlert, formatDatetimeForInput, parseUTCDatetime, getTodayInAEST, isPrepaymentApproaching, hasAppointments, getAppointmentSummary } from '../../utils/helpers';
import { useRouter } from '../common/Router';


const PetEdit = ({ petId }) => {
  const [pet, setPet] = useState(null);
  const [loading, setLoading] = useState(true);
  const { navigate } = useRouter();

  useEffect(() => {
    fetchPet();
  }, [petId]);

  const fetchPet = async () => {
    try {
      const response = await apiClient.get(`/pets/${petId}`);
      setPet(response.data);
    } catch (error) {
      console.error('Failed to fetch pet:', error);
      if (error.response?.status === 404) {
        navigate('/');
      }
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading pet record...</p>
        </div>
      </div>
    );
  }

  if (!pet) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <p className="text-gray-600">Pet record not found</p>
          <button
            onClick={() => navigate('/')}
            className="mt-4 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg"
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <AddPetModal 
      editPet={pet}
      onClose={() => navigate(`/pets/${petId}`)}
      onSuccess={() => {
        console.log('✅ Edit form onSuccess called');
        console.log('📍 Navigating to:', `/pets/${petId}`);
        showToast('Pet record updated successfully! ✅');
        
        // Small delay to ensure toast shows before navigation
        setTimeout(() => {
          navigate(`/pets/${petId}`);
        }, 100);
      }}
    />
  );
};

// Walk-in Form Modal - Simplified customer-facing form

export default PetEdit;
